import { Pipe, PipeTransform } from '@angular/core'
import { DatePipe } from '@angular/common'
import { FloDatePipe } from './flodate.pipe'
import { legacyParse } from '@date-fns/upgrade/v2'

@Pipe({ name: 'floDateYear' })
export class FloDateYearPipe implements PipeTransform {
  constructor(private datePipe: DatePipe, private floDatePipe: FloDatePipe) {}

  transform(startDate?: string | null, endDate?: string, time?: string, year?: string, isTbd?: boolean): string {
    const parsedStartDate = legacyParse(startDate)
    const parsedEndDate = legacyParse(endDate)

    let displayDate: any
    // Using parse will return a consistent instance of Date - Safari fix
    if (!startDate) {
      displayDate = 'N/A'
    } else if (year === 'year') {
      const momentStartDate = parsedStartDate
      displayDate = this.datePipe.transform(momentStartDate, 'y')
    } else if (time === 'time') {
      if (endDate) {
        const momentEndDate = parsedEndDate
        const momentStartDate = parsedStartDate
        const startTime = isTbd ? 'TBD' : this.datePipe.transform(momentStartDate, 'shortTime')
        const yearDate = this.datePipe.transform(momentEndDate, 'y')
        const floDate = this.floDatePipe.transform(startDate, endDate)
        displayDate = `${floDate}, ${yearDate} - ${startTime}`
      } else {
        const momentStartDate = parsedStartDate
        const startTime = this.datePipe.transform(momentStartDate, 'shortTime')
        const yearDate = this.datePipe.transform(momentStartDate, 'y')
        const floDate = this.floDatePipe.transform(startDate)
        displayDate = `${floDate}, ${yearDate}, ${startTime}`
      }
    } else if (endDate) {
      const yearDate = this.datePipe.transform(parsedEndDate, 'y')
      const floDate = this.floDatePipe.transform(startDate, endDate)
      displayDate = `${floDate}, ${yearDate}`
    } else {
      const yearDate = this.datePipe.transform(parsedStartDate, 'y')
      const floDate = this.floDatePipe.transform(startDate)
      displayDate = `${floDate}, ${yearDate}`
    }
    return displayDate
  }
}
